import { API_CONFIG } from "../constants";
import api from "../utils/api";
// import { setAlert } from "./alert";
import {
    GET_ALL_CHATS,
    TRIP_ERROR
} from "./types";

/*
  NOTE: we don't need a config object for axios as the
 default headers in axios are already Content-Type: application/json
 also axios stringifies and parses JSON for you, so no need for 
 JSON.stringify or JSON.parse
*/

// Get trips
export const getAllChats = (loggedInUser) => async (dispatch) => {
    try {
        const res = await api.get(`${API_CONFIG.production}/chat`);

        dispatch({
            type: GET_ALL_CHATS,
            payload: res.data,
        });
    } catch (err) {
        dispatch({
            type: TRIP_ERROR,
            payload: {
                msg: err?.response?.statusText,
                status: err?.response?.status,
            },
        });
    }
};